module.exports = __webpack_public_path__ + "img/prontuario_nuvem.1e67a453.jpg";